var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01625 6.01818C4.59827 6.01818 3.06247 4.52727 3.06247 2.13636C3.06247 1.61364 3.18588 0.918182 3.35043 0.55C3.40528 0.431818 3.41899 0.35 3.41899 0.286364C3.41899 0.140909 3.31386 0 3.12646 0C3.0579 0 2.9482 0.0181818 2.83393 0.0590909C1.13357 0.736364 0 2.52273 0 4.41818C0 7.08636 2.02946 9 4.7034 9C6.64144 9 8.33723 7.83636 8.93601 6.31818C8.98629 6.2 9 6.08182 9 6.01818C9 5.84091 8.86287 5.72273 8.71661 5.72273C8.6389 5.72273 8.56577 5.74091 8.46064 5.78636C8.11783 5.90455 7.56475 6.01818 7.01625 6.01818Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.8e7308934ff0eb1bb92ab7f077738fe7.svg";
export { ForwardRef as ReactComponent };